import { useCallback } from "react";
import { useLocation, useHistory, matchPath } from "react-router-dom";
import { useAuth } from "src/contexts/global/GlobalContext";

import { trackEvent } from "src/services/segment";
import { EVENT_TRACKING } from "src/consts/eventTracking";
import URL, { TEAM_TAB, url } from "src/consts/urlPaths";
import tours from "./tours";
import tourDependenciesComplete from "./util/tourDependenciesComplete";

const TEAM_TOUR_PATHS = [URL.TEAM_DETAILS, URL.TEAM_DETAILS_BASE_PATH];

const useGuidedTourTrigger = () => {
  const location = useLocation();
  const history = useHistory();
  const auth = useAuth();

  return useCallback(
    (tourName) => {
      if (!tours[tourName]) {
        return;
      }

      const tour = tours[tourName]({});

      if (!tourDependenciesComplete(auth.username, tour.dependsOn)) {
        return;
      }

      trackEvent(EVENT_TRACKING.GUIDED_TOUR_STARTED, {
        guided_tour: tourName,
      });

      const queryParams = new URLSearchParams(location.search);
      queryParams.set("guided_tour", tourName);

      if (tourName === "teamDetailsTour") {
        const teamMatch = TEAM_TOUR_PATHS.map((path) =>
          matchPath(location.pathname, { path, exact: true })
        ).find(Boolean);
        if (teamMatch?.params?.id) {
          history.push({
            pathname: url(URL.TEAM_DETAILS, {
              id: teamMatch.params.id,
              tabType: TEAM_TAB.DETAILS,
              workspaceId: teamMatch.params.workspaceId,
            }),
            search: `?${queryParams.toString()}`,
          });
          return;
        }
      }

      history.push({
        search: `?${queryParams.toString()}`,
        state:
          tourName === "filterSidebarTour"
            ? {
                sidebar: { action: "openSidebar", selectedTab: "filter" },
              }
            : undefined,
      });
    },
    [location, history, auth]
  );
};

export default useGuidedTourTrigger;
